import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { Branch } from '../../../../types';

type CellParams = ICellRendererParams<Branch> & {
  billingOnly: (branch: Branch) => boolean;
  editCallback: (item: Branch) => void;
};

@Component({
  selector: 'app-pan-cell-branches-list-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule],
  templateUrl: './cell-branches-list-actions.component.html',
  styleUrl: './cell-branches-list-actions.component.scss',
})
export class CellBranchesListActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
